<template>
    <modal :name="modalName" transition="fade" top="0" width="700" height="auto" draggable="true"
        @before-open="beforeOpen" :adaptive="true">
        <div class="modal-container">
            <div class="create-modal-header ">
                <h3>Log Entry</h3>
                <button @click=close>X</button>
            </div>
            <div class="modal-content">
                <div class="modal-intro-information">
                    <label>Visitor First Name</label>
                    <input ref="title" type="text" placeholder="First Name" class="modal-title" v-model="firstName" />
                    <label>Visitor Last Name</label>
                    <input ref="title" type="text" placeholder="Last Name" class="modal-title" v-model="lastName" />
                </div>
                <div class="modal-create-data">
                    <div class="modal-create-data-item">
                        <p class="item-header">Resident Name</p>
                        <option-dropdown-select v-if="showResidentOptions" class="search" style="top: 36px" :options="residentOptions"
                            :searchCallback="(data) => fetchResidents(data)"
                            :onOptionSelected="(option) => { residentData = option; showResidentOptions = false }" />
                        <button v-else-if="residentData != null" class="option-select-dropdown-button"
                            style="flex: 1; display: flex; align-items: center; justify-content: center;">
                            <p style="text-align: center;" @click="showResidentOptions = !showResidentOptions">
                                {{ residentData.name }} {{ residentData.last_name }}</p>
                        </button>
                        <button v-else class="option-select-dropdown-button"
                            style="flex: 1; display: flex; align-items: center; justify-content: center;">
                            <p style="text-align: center;" @click="showResidentOptions = !showResidentOptions">Search
                                for Residents</p>
                        </button>
                    </div>
                    <div class="modal-create-data-item">
                        <p class="item-header">Business Name</p>
                        <input ref="business-name" type="text" placeholder="Business Name" class="modal-title"
                            v-model="businessName" />
                    </div>
                    <div class="modal-create-data-item">
                        <p class="item-header">Visitor Phone Number</p>
                        <input ref="visitor-phone-number" type="text" placeholder="Visitor Phone Number"
                            class="modal-title" v-model="visitorPhoneNumber" />
                    </div>
                    <div class="modal-create-data-item">
                        <p class="item-header">Visitor Email</p>
                        <input ref="visitor-email" type="text" placeholder="Visitor Email" class="modal-title"
                            v-model="visitorEmail" />
                    </div>
                    <div class="modal-create-data-item">
                        <p class="item-header">License Plate Number</p>
                        <input ref="license-plate" type="text" placeholder="Visitor License Plate Number"
                            class="modal-title" v-model="licensePlate" />
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button @click="() => handlePress()">Log Entry</button>
            </div>
        </div>
    </modal>

</template>
<script>

import * as Constants from "../../js/constants.js";
import CTSRepository from "../../js/CTSRepository.js";
import OptionDropdownSelect from "../layout/OptionDropdownSelect.vue";

const NAME = Constants.CREATE_ENTRY_LOG_MODAL

export default {
    components: {
        OptionDropdownSelect
    },
    props: ["organizationData", "userData"],
    data() {
        return {
            modalName: NAME,
            firstName: "",
            lastName: "",
            residentUid: "",
            businessName: "",
            visitorPhoneNumber: "",
            visitorEmail: "",
            licensePlate: "",
            residentOptions: [
                // {
                //     "id": "abcd",
                //     "name": "Richard Dale"
                // },
                // {
                //     "id": "efgh",
                //     "name": "Jason Quintana"
                // }
            ],
            residentData: null,
            showResidentOptions: false
        }
    },
    watch: {
        residentData: function (newVal) {
            console.log("Entry Log New Resident Data", newVal)
        },
        organizationData: function() {
            this.fetchResidents("")
        }
    },
    methods: {
        show() {
            this.$modal.show(NAME);
        },
        close() {
            this.residentData = null;
            this.showResidentOptions = false;
            this.$modal.hide(NAME);
        },
        beforeOpen(event) {
            console.log('Before Opening...', event)

        },
        async fetchResidents(data) {
            new CTSRepository({
                organization_id: this.organizationData.organization_id
            }).fetchResidents(data).then(async (responseData) => {
                    console.log("Search Data", responseData);
                    let mappedData = await responseData.data.map(item => {
                        return {
                            name: `${item.first_name} ${item.last_name} - ${item.subdivision}`,
                            value: item.uid
                        }
                    });
                    console.log("Mapped Data", mappedData);

                    this.residentOptions = mappedData
                })
                .catch(() => {
                });

        },
        handlePress() {
            this.createEntryLog()
        },
        createEntryLog() {
            let body = {
                "type": "Visitor",
                "action": "ADMIT",
                "authorizer": this.userData.sub,
                "resident_uid": this.residentData.value,
                "visitor_first_name": this.firstName,
                "visitor_last_name": this.lastName,
                "visitor_license_plate": this.licensePlate,
                "visitor_contact": this.visitorPhoneNumber,
                "visitor_type": "Single Visit",
                "visitor_vendor_name": this.businessName,
                "party_key": "",
                "visit_id": ""
            }
            new CTSRepository(this.$props.organizationData).createEntryLog(body).then(response => {
                console.log("Create Entry Log Response", response);
                this.close();
            }).catch(err => console.error(err))
        }
    }
}
</script>
<style></style>